// extracted by mini-css-extract-plugin
export default {"athletePagesWrap":"AthletePageLayout_athletePagesWrap__FihZf","athleteContent":"AthletePageLayout_athleteContent__kIIA3"};